import React, { useState } from 'react';
import axios from 'axios';
import Footer from './Footer';

const CATEGORIES = [
  'Music/Instruments',
  'Media/Camera',
  'Radio/TV',
  'Protocol/Ushering',
  'Prayer',
  'Organization',
  'Time/Anything Needed',
  'Other',
];

const inputClass = "w-full border border-gray-300 dark:border-white/15 p-3 rounded-lg bg-white dark:bg-white/5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-white focus:border-gray-900 dark:focus:border-white transition-colors";

const Support = () => {
  const [fullName, setFullName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [otherCategory, setOtherCategory] = useState('');
  const [message, setMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [progress, setProgress] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  const toggleCategory = (category) => {
    setSelectedCategories((prev) =>
      prev.includes(category) ? prev.filter((c) => c !== category) : [...prev, category]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage('');
    setErrorMessage('');
    setSubmitting(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/support/upload`, {
        fullName,
        phone,
        email,
        categories: selectedCategories,
        otherCategory,
        message,
      });

      if (response.status === 200) {
        setSuccessMessage('Thank you for taking the time to submit your information and for your interest in supporting our upcoming concert.');
        setProgress(100);

        setFullName('');
        setPhone('');
        setEmail('');
        setSelectedCategories([]);
        setOtherCategory('');
        setMessage('');

        setTimeout(() => {
          setProgress(0);
          setSuccessMessage('');
        }, 10000);
      }
    } catch (error) {
      setErrorMessage('Failed to submit. Please try again.');
      setProgress(100);
      setTimeout(() => {
        setProgress(0);
        setErrorMessage('');
      }, 5000);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="bg-white dark:bg-black transition-colors duration-300">
      <div className="flex flex-col justify-center items-center gap-6 px-4 pt-[120px] pb-16 min-h-screen max-w-4xl mx-auto">
        <div className="bg-white dark:bg-[#111010] border border-gray-200 dark:border-white/10 text-gray-900 dark:text-white p-6 sm:p-8 rounded-xl w-full max-w-lg">
          <h2 className="text-2xl sm:text-3xl text-center mb-3 font-glsnecb tracking-wide uppercase">
            Support None Urabikoze Concert
          </h2>
          <p className="text-center text-gray-500 dark:text-gray-400 text-sm leading-relaxed mb-6">
            None Urabikoze Concert is coming, and we need your hands, hearts and talents.
            Whatever you can offer, we welcome your support. Share your details below.
          </p>
          <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
            <input
              type="text"
              placeholder="Full Name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
              className={inputClass}
            />
            <input
              type="tel"
              placeholder="Phone Number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              className={inputClass}
            />
            <input
              type="email"
              placeholder="Email Address (optional)"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={inputClass}
            />

            <div>
              <span className="block text-gray-700 dark:text-gray-300 text-sm font-medium mb-2">How can you support? (select all that apply)</span>
              <div className="flex flex-wrap gap-2">
                {CATEGORIES.map((category) => {
                  const isSelected = selectedCategories.includes(category);
                  return (
                    <button
                      key={category}
                      type="button"
                      onClick={() => toggleCategory(category)}
                      className={`text-sm px-3 py-2 rounded-full border transition-colors ${
                        isSelected
                          ? 'bg-gray-900 border-gray-900 text-white dark:bg-white dark:border-white dark:text-black'
                          : 'bg-white border-gray-300 text-gray-600 hover:border-gray-500 dark:bg-white/5 dark:border-white/15 dark:text-gray-300 dark:hover:border-white/40'
                      }`}
                    >
                      {category}
                    </button>
                  );
                })}
              </div>
              {selectedCategories.includes('Other') && (
                <input
                  type="text"
                  placeholder="Please specify"
                  value={otherCategory}
                  onChange={(e) => setOtherCategory(e.target.value)}
                  className={`${inputClass} mt-3`}
                />
              )}
            </div>

            <textarea
              placeholder="What can you support with?"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              rows="4"
              className={`${inputClass} resize-none`}
            />

            <button
              type="submit"
              disabled={submitting}
              className="w-full bg-gray-900 text-white dark:bg-white dark:text-black text-sm font-medium py-3 px-4 rounded-lg hover:bg-black dark:hover:bg-gray-200 disabled:opacity-50 transition-colors"
            >
              {submitting ? 'Submitting...' : 'Submit'}
            </button>
          </form>

          <p className="text-center text-gray-400 dark:text-gray-500 text-xs mt-6">
            For more details contact: <a href="tel:+250787703535" className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white">+250 787 703 535</a>{' '}
            or <a href="mailto:info@elayonemusic.org" className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white">info@elayonemusic.org</a>
          </p>
        </div>
      </div>

      {successMessage && (
        <div className="fixed top-6 left-4 right-4 sm:mx-auto sm:w-80 bg-green-100 text-green-900 border-green-500 pt-2 rounded-t-md shadow-md z-50">
          <div className="flex justify-center items-center">
            <span className="text-center p-1">{successMessage}</span>
          </div>
          <div className="h-1 mt-1 bg-green-300">
            <div style={{ width: `${progress}%` }} className="h-full bg-green-700 transition-all duration-500" />
          </div>
        </div>
      )}

      {errorMessage && (
        <div className="fixed top-6 left-4 right-4 sm:mx-auto sm:w-80 bg-red-100 text-red-900 border-red-500 pt-2 rounded-t-md shadow-md z-50">
          <div className="flex justify-center items-center">
            <span className="text-center p-1">{errorMessage}</span>
          </div>
          <div className="h-1 mt-1 bg-red-300">
            <div style={{ width: `${progress}%` }} className="h-full bg-red-700 transition-all duration-500" />
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Support;
